export type ILangData = {
	[key: string]: string
}

export interface ILocale {
	_id?: string
	langData: ILangData
	langKey: string
}

export interface ILocaleResponseData {
	errorCode: string
	message: string | null
	result: ILocale
}

export enum LocaleActionTypes {
	LOCALE_GET = 'LOCALE_GET',
}

export interface ILocaleGetAction {
	type: LocaleActionTypes.LOCALE_GET
	payload: ILocale
}

export interface ILocaleStore {
	langData: ILangData
	langKey: string
}

export type LocaleActions = ILocaleGetAction
